import React from 'react'
import { AMModal } from '../../ApiCenter/API_GET'

export const ImageViewer = ({ 
    isOpen, 
    onClose, 
    images, 
    currentIndex, 
    onNext, 
    onPrev 
}) => {
    if (!isOpen || !images || images.length === 0) return null

    const currentImage = images[currentIndex]

    return (
        <AMModal
            closeHandler={onClose}
            header_title={<span style={{color: '#212529'}}>Image {currentIndex + 1} of {images.length}</span>}
            size="xl"
            nofooter={true}
            style={{ zIndex: 1060 }}
        >
            <div style={{position: 'relative', minHeight: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {/* Navigation Arrows */}
                {images.length > 1 && (
                    <>
                        <button
                            onClick={onPrev}
                            className="btn btn-dark"
                            style={{
                                position: 'absolute',
                                left: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                                opacity: 0.7,
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px'
                            }}
                        >
                            <i className="bi bi-chevron-left" style={{fontSize: '24px'}}></i>
                        </button>
                        <button
                            onClick={onNext}
                            className="btn btn-dark"
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                zIndex: 10,
                                opacity: 0.7,
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px'
                            }}
                        >
                            <i className="bi bi-chevron-right" style={{fontSize: '24px'}}></i>
                        </button>
                    </>
                )}
                
                {/* Image Display */}
                <img 
                    src={currentImage?.s3Info} 
                    alt={currentImage?.image_name}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '70vh',
                        objectFit: 'contain'
                    }}
                />
            </div>
        </AMModal>
    )
}
